const gh_url = "https://github.com/tomgeek27"
const in_url = "https://www.linkedin.com/in/tommaso-amadori-7b967b116/"
const up_url = "https://www.upwork.com/freelancers/~01fbfefbf142852626"
const mail_url = "mailto:tommaso.amadori.dev@gmail.com"

export {gh_url, in_url, up_url, mail_url}